// BREACH RISK CLASSIFICATION
export const GET_BREACH_RISK_CLASSIFICATIONS = '/breach-risk-classification/query';
export const GET_BREACH_RISK_CLASSIFICATION = '/breach-risk-classification/';
export const POST_BREACH_RISK_CLASSIFICATION = '/breach-risk-classification/';
export const PUT_BREACH_RISK_CLASSIFICATION = '/breach-risk-classification/';
export const DELETE_BREACH_RISK_CLASSIFICATION = '/breach-risk-classification/';
export const CHECK_BREACH_RISK_CLASSIFICATION_EXISTS =
	'/breach-risk-classification/query';
